import React from 'react'
import FormSF from '../../../widgets/form/FormSF'
import MessageUI from '../../../widgets/output/MessageUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import ButtonUI from '../../../widgets/action/ButtonUI'
import EditorSF from '../../../widgets/input/EditorSF'
import SelectMultiSF from '../../../widgets/input/SelectMultiSF'
import './MessageUpdate.css'

const MessageUpdateUI = ({context, messageList, project, message, projectUserMap,
    // update
    editMode, onEditClick, onUpdateSubmit, updateSubmitted, onUpdateCancel,
    // fields
    html, onHtmlChange,   userIdList, projectUserList, onUsersChange,
    // delete
    deleteMode, onDeleteClick, onDeleteSubmit, onDeleteCancel, deleteSubmitted
  }) =>
  <div className='c_msg_upd'>
    <Line1UI
      messageList={messageList}
      project={project}
      message={message}
      projectUserMap={projectUserMap}
      onEditClick={onEditClick}
      onDeleteClick={onDeleteClick}
    />

    {
      editMode &&
      <FormSF context={context} messageList={messageList} buttonMessageKey='c_update'
        cancelMessageKey='c_cancel'
        onSubmit={onUpdateSubmit} onCancel={onUpdateCancel} busy={updateSubmitted}
      >
        <EditorSF html={html} onChange={onHtmlChange} autoFocus={true} />
        <div className='g_m_top_50' />
        <SelectMultiSF
          messageList={messageList}
          optionList={projectUserList
            .filter(projectUser => projectUser.roleId !== null)
            .map(projectUser => ({value: projectUser.userId, label: projectUser.name}))
          }
          onChange={onUsersChange}
          selectedKeys={userIdList}
        />
      </FormSF>
    }
    {
      !editMode &&
      <span dangerouslySetInnerHTML={{__html: message.message}} />
    }
    {
      deleteMode &&
      <div className='action g_flex_h'>
        <ButtonUI
          messageList={messageList}
          labelKey='c_cancel'
          transparent={true}
          onClick={onDeleteCancel}
        />
        <SpinnerUI show={deleteSubmitted} />
        <ButtonUI
          messageList={messageList}
          labelKey='c_delete'
          onClick={onDeleteSubmit}
          disabled={deleteSubmitted}
        />
      </div>
    }
  </div>

const Line1UI = ({messageList, project, message, projectUserMap, onEditClick, onDeleteClick}) =>
  <div className='g_flex_h line1'>
    {
      !message.createdByUserLeft &&
      <img className='avatar' alt=''
        src={projectUserMap[message.createdByUserId] &&
          projectUserMap[message.createdByUserId]['avatarUrl']
        }
      />
    }
    {
      message.createdByUserLeft &&
      <div className='icon icon-user' />
    }
    <div className='center'>
      {
        !message.createdByUserLeft &&
        <span className='name'>
          {message.createdByUserName}
        </span>
      }
      {
        message.createdByUserLeft &&
        <span className='name'>
          <s>{message.createdByUserName}</s>
        </span>
      }

      <span className='g_muted g_small'>
        {message.dateCreatedStr}
      </span>
      {
        message.updatedByUserName &&
        <div className='g_small'>
          <MessageUI messageList={messageList} messageKey='c_last_update' />:
          <span className='g_m_left_25'>
            {message.updatedByUserName}
          </span>
          <span className='g_muted g_m_left_50'>
            {message.dateUpdatedStr}
          </span>
        </div>
      }
    </div>
    {
      project.permissionList.includes('prj_participate') &&
      <div className='g_flex_h'>
        <span className='icon icon-pencil g_link_2' onClick={onEditClick} />
        <span className='icon icon-trash-o g_link_2' onClick={onDeleteClick} />
      </div>
    }
  </div>

export default MessageUpdateUI
